<template>
	<div>
		<h1>Study Information</h1>
		<i>General Information of the trial</i>
		<InputTextSingleLineMulti
			question="Who are the relevant stakeholders?"
			v-model="$tera.project.AuditWizard.stakeholder"
			placeholder="e.g. The Emergency Department consultants"
		/>
		<InputTextMultiLine
			question="How have the stakeholders been consulted?"
			placeholder="The topic has been discussed with Dr A and Dr B, who agreed this was an important issue for the department."
			v-model="$tera.project.AuditWizard.stakeholderConsultation"
		/>
		<!-- <InputTextMultiLine
			question="Who is the supervisor?"
			placeholder="Gerben Keijzers <Gerben.Keijzers@health.qld.gov.au>"
			v-model="$tera.project.AuditWizard.supervisor"
		/> -->
		<InputTextSingleLine
			question="Who is the supervisor?"
			placeholder="e.g. https://www.crd.york.ac.uk/prospero/ , https://osf.io/"
			v-model="$tera.project.AuditWizard.supervisorEmail"
		/>
		<InputTextMultiLine
			question="Description of the audit question and justification for undertaking the audit, including summary of relevant guidelines or studies."
			placeholder="Despite known improvements in patient care, significant variation in healthcare professionals’ knowledge and use of CDAs has been
reported, with many rules underutilised in clinical practice [REFERENCES]"
			v-model="$tera.project.AuditWizard.auditQuestionDescription"
		/>
		<InputTextSingleLine
			question="What is the key document (the standard or guideline) against which your are auditing a process and/or practice? "
			placeholder=""
			v-model="$tera.project.AuditWizard.keyDocument"
		/>
		<InputTextMultiLine
			question="What is the specific objectives of this audit?"
			placeholder="e.g. the aim of this study was to (i) determine clinicians’ knowledge, self-reported use and documentation of CDAs in a large ED in Australia, and (ii) to identify behavioural determinants influencing the implementation."
			v-model="$tera.project.AuditWizard.auditObjective"
		/>
		<!-- <InputTextMultiLine
			question="What is the method of data collection?"
			placeholder="Interview
Questionnaire
Direct observation
Focus group
Patient records
Existing datasets
Other

Specify (for all above)"
			v-model="$tera.project.AuditWizard.dataCollectionMethod"
		/> -->
		<InputSelectMultiWithoutOthers
			question="What is the method of data collection?"
			:options="options.methodCollection"
			v-model="$tera.project.AuditWizard.methodOfDataCollection"
		/>
		<InputSelectMultiWithoutOthers
			v-if="
				$tera.project.AuditWizard.methodOfDataCollection.some(
					item => item.label === 'Existing data'
				)
			"
			question="What is the source of the existing data?"
			:options="options.existingData"
			v-model="$tera.project.AuditWizard.selectedExistingData"
		/>
		<InputTextSingleLine
			v-if="
				$tera.project.AuditWizard.selectedExistingData.some(
					item => item.label === 'Other'
				)
			"
			question="Specify Other"
			v-model="$tera.project.AuditWizard.otherExistingData"
			placeholder="e.g. Research Databases, Manual Records"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>
<script>
import InputTextMultiLine from "@/components/InputTextMultiLine.vue";
import InputTextSingleLineMulti from "@/components/InputTextSingleLineMulti.vue";
import OutputAuditStudyInformation from "./OutputAuditStudyInformation.vue";
import InputSelectMultiWithoutOthers from "@/components/InputSelectMultiWithoutOther";
import InputTextSingleLine from "@/components/InputTextSingleLine.vue";
// import InputSelectMulti from "@/components/InputSelectMulti.vue";

export default {
	name: "ViewAuditStudyInformation",
	components: {
		InputTextMultiLine,
		InputTextSingleLineMulti,
		// InputSelectMulti
		InputSelectMultiWithoutOthers,
		InputTextSingleLine
	},
	data() {
		return {
			outputComponent: OutputAuditStudyInformation,
			options: {
				methodCollection: [
					{ label: "Survey" },
					{ label: "Interview" },
					{ label: "Observation" },
					{ label: "Existing data" }
				],
				existingData: [
					{ label: "Triage notes" },
					{ label: "Operational logs" },
					{ label: "Electronic Health Record" },
					{ label: "Other" }
				]
			}
		};
	}
};
</script>
